import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import TagManagerHeader from './TagManagerHeader';
import TagManagerTable from './TagManagerTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TagManagerListingPage = () => {
  return /*#__PURE__*/_jsxs(ListingPage, {
    pageLayout: "full-width",
    headerComponent: /*#__PURE__*/_jsx(TagManagerHeader, {}),
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(TagManagerTable, {})]
  });
};
export default TagManagerListingPage;